import React from "react";

import TallargeLogoFull from "../../assets/Tallarge_final.png";
import TallargeLogoIcon from "../../assets/Tallarge_LOGO.png";
import IconCompany from "../../assets/tallarge_icon_company.ico";

export const SYSTEM_ADMIN_MENU_ITEMS = [
  { key: "companyAccounts", label: "公司帳號", icon: IconCompany },
];

const styles = {
  sidebar: {
    position: "relative",
    zIndex: 20,
    width: 264,
    minWidth: 0,
    minHeight: 0,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    padding: "18px 18px 0",
    background: "#FFFFFF",
    borderRight: "1px solid rgba(15,23,42,0.08)",
    overflow: "hidden",
    transition: "width 220ms ease, padding 220ms ease",
  },
  sidebarCollapsed: {
    width: 84,
    padding: "18px 12px 0",
  },
  logoStage: {
    height: 64,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 8,
  },
  logo: {
    display: "block",
    width: 150,
    maxWidth: "100%",
    height: "auto",
    objectFit: "contain",
  },
  logoIcon: {
    display: "block",
    width: 48,
    height: 48,
    objectFit: "contain",
  },
  menu: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    minHeight: 0,
  },
  menuButton: {
    width: "100%",
    minHeight: 58,
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    gap: 14,
    padding: "0 18px",
    border: 0,
    borderRadius: 18,
    background: "linear-gradient(135deg, #FF9736 0%, #F67E1F 100%)",
    color: "#FFFFFF",
    fontFamily: "inherit",
    fontSize: 16,
    fontWeight: 800,
    letterSpacing: "-0.01em",
    textAlign: "left",
    cursor: "pointer",
    boxShadow: "0 10px 24px rgba(246,139,44,0.24)",
  },
  menuButtonCollapsed: {
    justifyContent: "center",
    padding: "7px 0",
    gap: 0,
  },
  iconWrap: {
    width: 40,
    height: 40,
    flex: "0 0 40px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
  },
  icon: {
    display: "block",
    width: 34,
    height: 34,
    objectFit: "contain",
    flexShrink: 0,
    pointerEvents: "none",
    userSelect: "none",
  },
  label: {
    minWidth: 0,
    flex: 1,
    lineHeight: 1.4,
    whiteSpace: "nowrap",
  },
};

export default function SystemAdminSidebar({
  activeKey = "companyAccounts",
  collapsed = false,
  onSelect,
}) {
  const item = SYSTEM_ADMIN_MENU_ITEMS[0];
  const active = activeKey === item.key;

  return (
    <aside
      style={{
        ...styles.sidebar,
        ...(collapsed ? styles.sidebarCollapsed : {}),
      }}
      aria-label="系統管理側邊欄"
    >
      <div style={styles.logoStage}>
        {collapsed ? (
          <img src={TallargeLogoIcon} alt="Tallarge" style={styles.logoIcon} draggable={false} />
        ) : (
          <img src={TallargeLogoFull} alt="Tallarge" style={styles.logo} draggable={false} />
        )}
      </div>

      <nav style={styles.menu} aria-label="系統管理主選單">
        <button
          type="button"
          title={collapsed ? item.label : undefined}
          aria-label={item.label}
          aria-current={active ? "page" : undefined}
          onClick={() => onSelect?.(item.key)}
          style={{
            ...styles.menuButton,
            ...(collapsed ? styles.menuButtonCollapsed : {}),
          }}
        >
          <span style={styles.iconWrap}>
            <img src={item.icon} alt="" aria-hidden="true" style={styles.icon} draggable={false} />
          </span>
          {!collapsed && <span style={styles.label}>{item.label}</span>}
        </button>
      </nav>
    </aside>
  );
}
